import { ReactNode } from 'react';
import { SidebarLayout } from './SidebarLayout';
import { SidebarProvider } from '@/contexts/SidebarContext';

interface AppShellProps {
  children: ReactNode;
  businesses?: any[];
  onRefreshBusinesses?: () => void;
}

export const AppShell = ({ children, businesses, onRefreshBusinesses }: AppShellProps) => {
  return (
    <SidebarProvider>
      <SidebarLayout 
        businesses={businesses} 
        onRefreshBusinesses={onRefreshBusinesses}
      >
        {children}
      </SidebarLayout>
    </SidebarProvider>
  );
};